import http from '../core/http-common'
import { IEmployeeSummary, ISearchFirmEmployee } from '../types/Employee'

class EmployeeService {
  getEmployeeSummery(employeeId: number) {
    return http.get<IEmployeeSummary>(`/Employee/GetEmployeeSummery?employeeId=${employeeId}`)
  }

  getTeamEmployeeSummaryList(employeeId: number) {
    return http.get<IEmployeeSummary[]>(`/Employee/GetTeamEmployeeSummaryList?employeeId=${employeeId}`)
  }

  getEmployeeSummeryListByManagerId(managerId: number) {
    return http.get<IEmployeeSummary[]>(`/Employee/GetEmployeeSummeryListByManagerId?managerId=${managerId}`)
  }

  getEmployeePhotoUrl(employee: IEmployeeSummary) {
    return `/Employee/GetEmployeePhoto?employeeId=${employee.id}`
  }

  getEmployeePhotoBase64ById(employeeId: number) {
    return `/Employee/GetEmployeePhotoBase64String?employeeId=${employeeId}`
  }

  getEmployeePhotoUrlById(employeeId: number) {
    return `/Employee/GetEmployeePhoto?employeeId=${employeeId}`
  }

  updateDedicatedShowInfo() {
    return http.post<any>('/EmployeeDedicated/UpdateDedicatedShowInfo')
  }

  getSearchFirmEmployeeByFullName(searchText: string) {
    return http.get<ISearchFirmEmployee[]>('Employee/SearchFirmEmployeeByFullName?searchText=' + searchText)
  }
  uploadEmployeeProfilePhoto(file: any) {
    let formData = new FormData()
    formData.append('file', file)
    return http.post(`/Employee/SaveEmployeePhoto`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
  deleteEmployeeProfilePhoto() {
    return http.post('/Employee/DeleteEmployeePhoto')
  }
}

export default new EmployeeService()
